import { Metrics } from '../../../../../constants/Dashboards'
import { EventSpace2ActionTypes } from '../../../../../actions/dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'
import {StoresTopPayload, TopStores} from "../../types";

/**
 * Event Space 2 Stores Top
 */
const EventSpace2StoresTop = buildAsyncStatReducer({
  key: Metrics.EVENTSPACE2_STORES_TOP,
  types: EventSpace2ActionTypes.DASHBOARD_EVENTSPACE2_STORES_TOP,
  transform: (state, { payload }): TopStores => {
    return payload.map(({ store_code: storeCode, count }: StoresTopPayload) => ({
      storeCode,
      count,
    }))
  },
})

export default EventSpace2StoresTop